
  import { mapActions, mapGetters } from 'vuex'
  import { ESTADOS } from '../_mock/uf'
  export default {
    data() {
      return {
        solicitante: {
          endereco: {},
        },
        items: ESTADOS,
        loadingCnpj: false,
        loadingAndDisabledSolicitante: false,
        rules: [(v) => !!v || 'Campo obrigatório'],
        emailRules: [
          (v) => !!v || 'O e-mail é obrigatório',
          (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
        ],
      }
    },
    computed: {
      ...mapGetters('unidade', ['unidadeInformation']),
    },
    methods: {
      ...mapActions('solicitacao-sdc', [
        'searchExistingCompany',
        'createSolicitacaoCompany',
      ]),
      async handlerFetchCnpj() {
        this.loadingCnpj = true
  
        const cpfcnpj = this.solicitante.cpf_cnpj.replace(/\D/g, '')
        try {
          const data = await this.searchExistingCompany(cpfcnpj)
          console.log(data)
        } catch (error) {
          console.error(error)
          this.$toast.error('houve algum erro: ' + error)
        } finally {
          this.loadingCnpj = false
        }
      },
      async handlerCreateSolicitacao() {
        const formValidate = this.$refs.form.validate()
        if (!formValidate) {
          return false
        }
  
        /* eslint-disable camelcase */
        const { cpf_cnpj, telefone_contato, ...remainingData } = this.solicitante
        const cpfCnpjSemCaracteres = cpf_cnpj.replace(/\D/g, '')
        const telefoneContatoSemCaracteres = telefone_contato.replace(/\D/g, '')
        /* eslint-enable camelcase */
        const data = {
          ...remainingData,
          cpf_cnpj: cpfCnpjSemCaracteres,
          telefone_contato: telefoneContatoSemCaracteres,
          responsavel: {
            cpf_cnpj: this.unidadeInformation.cpfcnpj.replace(/\D/g, ''),
            unidade: this.unidadeInformation.unidade,
          },
        }
        this.loadingAndDisabledSolicitante = true
        try {
          await this.createSolicitacaoCompany(data)
          this.solicitante = {
            endereco: {},
          }
          this.$refs.form.resetValidation()
          this.$toast.success('Solicitado com sucesso')
        } catch (error) {
          console.error(error)
          this.$toast.error('houve algum erro: ' + error)
        } finally {
          this.loadingAndDisabledSolicitante = false
        }
      },
    },
  }
  